import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import Mediator from "../../services/Mediator";
import {FILTER_CHANGED} from "../../constants/event-types";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import NoSsr from "@material-ui/core/NoSsr";
import EnhancerIcon from "../../../../icons/EnhancerIcon";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import effectsMenu from "../../constants/effects-menu";
import {toggleEffect} from "../../AC/toggle-effect";
import {withStyles} from "@material-ui/core/styles";
import {applyVisionHubFilter} from "../../AC/apply-vision-hub-filter";
import {userSelector} from "../../selectors";

const styles = {
  root: {
    padding: `12px 2px 12px 8px`,
    borderRadius: `3px`
  }
};

class Effects extends Component {
  static propTypes = {
    toggleEffect: PropTypes.func,
    applyVisionHubFilter: PropTypes.func,
    selected: PropTypes.object,
    classes: PropTypes.object,
    user: PropTypes.object
  };
  state = {
    anchorEl: null,
    filters: [],
    clipPath: null
  };
  isGuest = this.props.user.name === `гость` || !this.props.user.name;
  setStateFromOImage = (oImage) => {
    const {filters, clipPath} = oImage;
    this.setState({
      filters,
      clipPath
    });
  };
  componentDidMount() {
    Provider.subscribe(FILTER_CHANGED, (_, target) => {
      this.setStateFromOImage(target);
    });
  }
  componentDidUpdate(prevProps) {
    const {selected: prevSelected} = prevProps;
    const {selected} = this.props;
    if (
      selected &&
      Mediator.isImage(selected) &&
      JSON.stringify(selected) !== JSON.stringify(prevSelected)
    ) {
      this.setStateFromOImage(selected);
    }
  }
  componentWillUnmount() {
    Provider.unsubscribe(FILTER_CHANGED);
  }
  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };
  handleClose = () => {
    this.setState({anchorEl: null});
  };
  toggleEffect = (effectName) => () => {
    this.props.toggleEffect(effectName);
    this.handleClose();
  };
  isSelected = (id) => {
    const {filters, clipPath} = this.state;
    if (typeof id === `number`) {
      return !!filters[id];
    }
    return Mediator.isActiveClipPath(clipPath, id);
  };
  mapDefaultEffects = ({id, title, name}) => (
    <MenuItem
      key={id}
      selected={this.isSelected(id)}
      onClick={this.toggleEffect(name)}
    >
      <span className={`effect-icon ${` effect-icon_${name}`}`} />
      {title}
    </MenuItem>
  );
  render() {
    const {selected, classes, user} = this.props;
    const {anchorEl} = this.state;
    const isGuest = user.name === `гость` || !user.name;
    return (
      selected &&
      Mediator.isImage(selected) && (
        <NoSsr>
          <div className="panel-control__item">
            <Tooltip title="Эффекты">
              <div>
                <IconButton
                  aria-owns={anchorEl ? `effects-menu` : void 0}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                  classes={{root: classes.root}}
                >
                  <EnhancerIcon />
                  <ArrowDropDownIcon />
                </IconButton>
              </div>
            </Tooltip>
            <Menu
              id="effects-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              {Object.values(effectsMenu)
                .slice(0, 2)
                .map(this.mapDefaultEffects)}
              {/* Андрей хотел именно тут и именно на 3 место */}
              {/* splice в такой ситуации не помогает */}
              {/* {isGuest && selected.remoteId && (
                <MenuItem
                  key="anime-filter"
                  selected={false}
                  onClick={() =>
                    this.props.applyVisionHubFilter(selected, `anime_gan`)
                  }
                >
                  <span className="anime-icon" />
                  Аниме фильтр
                  <sup className="effect-new-label">new!</sup>
                </MenuItem>
              )}*/}
              {Object.values(effectsMenu)
                .slice(3, effectsMenu.length)
                .map(this.mapDefaultEffects)}
            </Menu>
          </div>
        </NoSsr>
      )
    );
  }
}

export default connect(
  (state) => ({
    user: userSelector(state)
  }),
  {
    toggleEffect,
    applyVisionHubFilter
  }
)(withStyles(styles)(Effects));
